export default function useSortAssessmentsByToc() {

    const orderTopicLessons = (topic, index, newArray) => {
        let i = index;
        if (topic) {
            topic?.lessons?.forEach(l => {
                let findIndex = newArray.findIndex(c => c.lessonId == l.id)
                if (findIndex != -1) {
                    newArray[findIndex] = { ...newArray[findIndex], index: i }
                    i++
                }
            });
        }
        return i;
    }

    return (array, lessonByTopic, justLessons = false) => {

        let i = 1
        let newArray = array
        lessonByTopic?.lessons?.forEach(t => {
            i = orderTopicLessons(t, i, newArray)
        });
        if (!justLessons) {
            lessonByTopic?.enrichment?.forEach(t => {
                i = orderTopicLessons(t, i, newArray)
            });
            lessonByTopic?.contest?.forEach(t => {
                i = orderTopicLessons(t, i, newArray)
            });
        }

        newArray = newArray.filter(a => !!a.index).sort((a, b) => a.index - b.index)
        return newArray
    }

}
